import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/General/PluginAddDeleteList";
import {PostToPbx, PostToPbx2} from "../../../../api/http-post";
import {LoadDataAnyEndpoint} from "../../../../api/fn";
import {Col, Row, Table,Switch} from "antd";
import {fetchDataEntity} from "../../../../api/entity-data";
import GenericComboBox from "../../../../components/General/GenericComboBox";


class SettingAllocationUserQueuePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Companies:[],
            Projects:[],
            Data:[],
            Voips: [],
            CompanyVoips:[],
            Users: [],
            isLoading: false,
            component: "list",
            newEntry: {},
            selectedCompany: "",
            selectedProject: "",
            Queues: [],
            QueueCloudCalls:[],
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this);
        await fetchDataEntity("Projects", "", "", this, undefined, "common/entity/modules/list");
        await fetchDataEntity("Queues", "", "", this, undefined, "common/entity/QueueAgent/list");
        await fetchDataEntity("CompanyVoips", "", "", this, undefined, "common/entity/AllocationCompanyVoip/list");

        await this.loadInitialData()
    }

    loadInitialData = async () => {
        //await this.loadData("modules","Projects");
        // AllocationCompanyVoip
        await this.loadData("AllocationUserViop", "Voips", (data) => this.fetchVoipQueue(data));
        await this.loadUsers();
        await this.fetchVoipQueue();
    }
    loadUsers = async () => {
        let userInfo = GetUserToken();
        let hub = {};
        // hub.Org = userInfo.Org;
        let endpoint = "/user/list";
        await LoadDataAnyEndpoint(hub, endpoint, "Users", this, (data) => {
            console.log("loadUsers > ", data)
        });

    }
    handleChangeCompany = async (val, key) => {
        this.setState({
            [key]: val,
        });
    }

    fetchVoipQueue = async (dataIn) => {
        let _this = this;
        let hub = {};
        await this.PostExternal(hub, "/manager/entity/list/queues", "Queues", (data) => {
            let ls = [];
            for (let i in data) {
                let row = data[i];
                ls.push(row)
            }
            _this.setState({
                QueueCloudCalls: ls
            })
        })
    }
    getInfoLogin = () => {
        let user = GetUserToken();
        let username = user.Username, role = user.Role, org = user.Org, outbound = '';
        for (let i in this.state.Voips) {
            let row = this.state.Voips[i];
            if (row.user === username) {
                org = row.companycode;
                outbound = row.outboundnumber
            }
        }
        return {org, role, username, outbound}
    }
    loadData = async (targetEntity, stateKey, feedback) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            console.log("SettingSetupSitePage loadInitialData response > ", post, " > ", data);
            await _this.setState({
                [stateKey]: data.RESULT
            })
            feedback(data.RESULT);
        });
    }
    PostExternal = async (hub, endpoint, stateKey, feedback) => {
        await PostToPbx2(hub, endpoint, async (dataIn) => {
            let data = [];
            if (dataIn !== null) {
                data = dataIn.RESULT;
            }
            console.log(endpoint + " response ---> ", endpoint, " > ", hub, data);
            feedback(data)
        });
    }
    submitQueque=async (checked,record)=>{
        delete record.statusSwitch;
        let _this = this;
        record.isin = checked;
        let hub = {...record};
        let endpoint = "/desk/queue/manage";

        this.setState({
            isLoading: true,
        });
        console.log("submitQueque > ",checked," > ",record," > ",hub)
        await PostToPbx(hub, endpoint, async (data) => {
            await this.loadData("AllocationUserViop", "Voips", (data) => _this.fetchVoipQueue(data));
        });

    }

    getValuesStateOptions = (stateKey, innerKey, innerDisplay, orgKey) => {
        let data = this.state[stateKey];
        let ls = [];
        for (let i in data) {
            let row = data[i];
            let key = row[innerKey];
            let val = row[innerDisplay];
            console.log("getValuesStateOptions > ", row, " > ", this.state.selectedCompany, " > ", this.state.selectedProject);
            if (row[orgKey] !== this.state.selectedCompany) {
                continue
            }
            ls.push({
                key: key,
                val: val
            });
        }
        return ls
    }
    getQueuesOptions = () => {
        let ls = [];
        let {org,role}=this.getInfoLogin()
        for (let i in this.state.Queues) {
            let row = this.state.Queues[i];
            if (org === row.Org) {
                ls.push({
                    key: row.Name,
                    val: row.Name.toLocaleUpperCase()
                })
            }
        }
        return ls
    }
    getInfoLogin = () => {
        let user = GetUserToken();
        let username = user.Username, role = user.Role, org = user.Org, outbound = '';
        for (let i in this.state.Voips) {
            let row = this.state.Voips[i];
            if (row.agent === username) {
                org = row.companycode;
                outbound = row.outboundnumber
            }
        }
        return {org, role, username, outbound}
    }
    renderProjectSelection = () => {

        let data = [];
        let company = this.state.selectedCompany;
        for (let i in this.state.Projects) {
            let row = this.state.Projects[i];
            console.log("&&&&--isMo> ", company, " > ", row.org)
            if (company === row.org) {
                data.push(row)
            }
        }
        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={data}
                label={"Select Project"}
                name={"selectedProject"}
                message={"Please select your project!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedProject}
                recordOptionKey={"name"}
                recordOptionValue={"name"}
                recordOptionDisplay={"name"}
                noCondition={true}
            />
        )
    }
    renderCompaniesSelection = () => {

        return (
            <GenericComboBox
                displayConditionStateKey={this.state.component}
                displayConditionStateValue={"list"}
                data={this.state.Companies}
                label={"Select Company"}
                name={"selectedCompany"}
                message={"Please select your company!"}
                handleChange={this.handleChangeCompany}
                getValue={this.state.selectedCompany}
                recordOptionKey={"CustomerNumber"}
                recordOptionValue={"CustomerNumber"}
                recordOptionDisplay={"DisplayName"}
                noCondition={true}
            />
        )
    }
    renderQueueSelection = () => {
        let _this = this;
        let ls = [];
        let user = GetUserToken();
        let org = user.Org;
        if(user.Role==="super"){
            org = this.state.selectedCompany
        }

        const getVoipCompany=(inOrg)=>{
            for(let i in _this.state.CompanyVoips){
                let row=_this.state.CompanyVoips[i];
                if(row.companycode===inOrg&&row.org===org){
                    return true;
                }
            }
            return false;
        }
        for (let i in this.state.QueueCloudCalls) {
            let row = this.state.QueueCloudCalls[i];
            if(getVoipCompany(row.Org)){
                ls.push(row)
            }
        }


        console.log("renderQueueSelection555 > ",org," > ",this.state.QueueCloudCalls)

        return (

                <GenericComboBox
                    displayConditionStateKey={this.state.component}
                    displayConditionStateValue={"list"}
                    data={ls}
                    label={"Select Queue"}
                    name={"selectedQueue"}
                    message={"Please select your queue!"}
                    handleChange={this.handleChangeCompany}
                    getValue={this.state.selectedQueue}
                    recordOptionKey={"Name"}
                    recordOptionValue={"Name"}
                    recordOptionDisplay={"Name"}
                    noCondition={true}
                />

        )
    }

    renderList=()=>{
        let _this = this;
        let ls=[];
        let columns=[
            {dataIndex:"queuename",title:"Queue Name"},
            {dataIndex:"outbound",title:"Outbound"},
            {dataIndex: "agentFullname",title:"Agent"},
            {dataIndex: "statusSwitch",title:"status"}
        ];
        let data = this.state.Queues;
        const findAgentFullName=(email)=>{
            let name="";
            for(let i in _this.state.Users){
                let row = _this.state.Users[i];
                if(email !== row.Username){continue}
                name = row.FullName;
            }
            return name;
        }
        const onChangeSwitch=async (checked,record)=>{
            delete record.agentFullname;
            delete record.statusSwitch;
            console.log("onChangeSwitch > ",checked," > ",record)
            await _this.submitQueque(checked,record)

        }
        const findStatusSwitch=(rowIn)=>{

            if(rowIn.isin){
                return(
                    <div><Switch defaultChecked onChange={(checked)=>onChangeSwitch(checked,rowIn)} style={{backgroundColor:"green"}} /> <span style={{marginLeft:10,color:"green"}}>Online</span></div>
                )
            }
            return(
                <div><Switch onChange={(checked)=>onChangeSwitch(checked,rowIn)} style={{backgroundColor:"red"}}/><span style={{marginLeft:10,color:"red"}}>Offline</span></div>
            )
        }

        for(let i in data){
            let row=data[i];
            console.log("RenderList > 1",row.org," > ",row," > ",this.state.Queues)
            if(row.org!==this.state.selectedCompany){continue}
            if(row.queuename!==this.state.selectedQueue){continue}
            row.agentFullname = findAgentFullName(row.agent);
            row.statusSwitch=findStatusSwitch(row);
            ls.push(row)
        }




        return (
            <Table
                columns={columns}
                dataSource={ls}
                bordered
                /* title={() => 'Period'}*/
                /*footer={() => 'Footer'}*/
            />
        )

    }

    render() {
        //const projects = this.getValuesStateOptions("Projects","name","name","org");
        const users = this.getValuesStateOptions("Users", "Username", "FullName", "Org");
        const queues = this.getQueuesOptions()
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Allocate User to Queue</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <Row style={{margin: 10}}>
                            <Col span={12}>
                                {this.renderCompaniesSelection()}
                            </Col>
                            <Col span={12}>
                                {this.renderQueueSelection()}
                            </Col>
                        </Row>
                        <Row style={{margin: 10}}>
                            <Col span={24}>
                                {this.renderList()}
                            </Col>
                        </Row>

                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(SettingAllocationUserQueuePage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
